import React, { createContext, useContext } from 'react'
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material'
import { lightTheme } from 'utils/theme/theme'
import GlobalStyles from '@mui/material/GlobalStyles'

type ThemeMode = 'light'

type ThemeContextType = {
  themeMode: ThemeMode
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => (
  <ThemeContext.Provider value={{ themeMode: 'light' }}>
    <MuiThemeProvider theme={lightTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  </ThemeContext.Provider>
)

export const useThemeContext = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useThemeContext must be used within a CustomThemeProvider')
  }
  return context
}
